<template lang="pug">
	.search-page
		.sfc-container
			.header
				sfc-breadcrumbs(:breadcrumbs-list="breadcrumbList")
			.padded-container
				sfc-search
</template>

<style lang="stylus" scoped>
	
	@import '~assets/css/redesign-v1/variables.styl'

	.search-page
		.header
			padding: 26px 0
			text-align: center
			max-width: 1140px
			margin: 0 auto
			@media (max-width: 767px)
				padding: 18px 0
			@media (min-width: 768px) and (max-width: 993px)
				padding: 18px 0 60px
			h1
				margin: 26px auto 18px
				text-align: center
				@media (max-width: 991px)
					margin: 16px auto 18px
			a.cta-link
				justify-content: center
		p
			color: body-font-color-black

		.padded-container
			max-width: 1440px
			margin: 0 auto
			padding: 0
			@media (min-width: 1200px)
				padding: 0 48px
			@media (max-width: 1199px)
				padding: 0 24px
			@media (max-width: 992px)
				padding: 0 16px

</style>

<script>
	import SfcSearch from '@/common/components/redesign-v1/sfc-search'
	import SfcBreadcrumbs from '@/common/components/redesign-v1/sfc-breadcrumbs'

	import Vue from 'vue'

	export default {
		layout: "redesign-v1/default",
		components: {
			SfcSearch,

			SfcBreadcrumbs
		},
		async asyncData({ params, store, app, error, req, redirect, query }) {
			return {
				breadcrumbList: [
					{href: `${store.state.config.sfcHost}`, name: "Home"},
					{href: "", name: `Search`}
				]
			}
		},
		data() {
			let version
			version = "v3"
			return {
				version: version,
				ready: false,
				breadcrumbList: []
			};
		},
		head() {
			return {
				title: `Search - Saving for College`,
				meta: [{
						hid: 'description',
						name: 'description',
						content: `Search content in savingforcollege.com`
					},
					{
						hid: 'og-description',
						name: 'og:description',
						property: 'og:description',
						content: `Search content in savingforcollege.com`
					},
					{
						hid: 'og-title',
						name: 'og:title',
						property: 'og:title',
						content: `Search - Saving for College`
					}
				],
				link: [
					{ hid: "canonical_url", rel: "canonical", href: "https://www.savingforcollege.com/search"}
				],
				__dangerouslyDisableSanitizers: ['title', 'meta']
			}
		}
	}
</script>